import { get } from 'lodash'

import threedocean from './3docean'
import audiojungle from './audiojungle'
import codecanyon from './codecanyon'
import graphicriver from './graphicriver'
import photodune from './photodune'
import themeforest from './themeforest'
import videohive from './videohive'
import defaults from './defaults'

const configs = {
  '3docean': threedocean,
  audiojungle,
  codecanyon,
  graphicriver,
  photodune,
  themeforest,
  videohive,
  defaults
}

/**
 * Returns specific site config property value with fallback to default one
 * @param currentSite {String}
 * @param configPath {String}
 * @returns {*}
 */
export const getConfigBySite = (currentSite, configPath) => {
  return (
    get(configs[currentSite], configPath) || get(configs.defaults, configPath)
  )
}

export default configs



// WEBPACK FOOTER //
// ./config/sites/index.js